import React from 'react'
import { AccordionProps } from './types'
import { StyledAccordion } from './styled'

export const Accordion: React.FC<AccordionProps> = ({ title, children, defaultOpen, size, className }) => {
  return (
    <StyledAccordion title={title} defaultOpen={defaultOpen} size={size} className={className}>
      {children}
    </StyledAccordion>
  )
}
